import { useState } from "react"
import { VenereBodyScanBox } from "../../../index"
import { useScrollToTop } from "../../shared/hooks/useScrollToTop"
import { useVenereDialog } from "../../shared/hooks/useVenereDialog"
import VenereSimpleLayout from "../../shared/pages/VenereSimpleLayout"
import { VenereButton, VenereDialog } from "../../shared/ui"

const VenereRegisterWeight = () => {
  const [weight, setWeight] = useState<string>("")
  
  // Auto scroll to top when navigating to this page
  useScrollToTop()
  
  // Dialog hook
  const { isOpen, config, showDialog, hideDialog } = useVenereDialog()

  const handleWeightChange = (value: string) => {
    // Only allow numbers and decimal point
    if (value === "" || /^\d*\.?\d*$/.test(value)) {
      setWeight(value)
    }
  }

  const onRegisterClick = () => {
    console.log(weight)
    
    // Show success dialog
    showDialog({
      title: "Peso registrato!",
      content: (
        <div className="text-center">
          <div className="venere-text-secondary">
            Il tuo peso di {weight} kg è stato registrato con successo.
          </div>
        </div>
      ),
      primaryButton: {
        text: "OK",
        onClick: () => {
          hideDialog()
          // You can add navigation here if needed
        },
      },
      showCloseButton: false,
    })
  }

  return (
    <VenereSimpleLayout
      showBackButton={true}
      backButtonText="Back"
    >
      <div className="w-full mx-auto py-8">
        <div className="bg-white rounded-xl p-6 md:p-8">
          <div className='flex flex-col items-center gap-6'>
            <div className='venere-text-heading text-center'>
              Registra il tuo peso di oggi
            </div>
            <div className='venere-text-subheading text-center'>
              Non perderti nemmeno uno step dei tuoi progressi.
            </div>
            
            <div className="w-full max-w-xs space-y-1">
              <label className="block venere-text-primary">
                Peso attuale
              </label>
              <div className="relative">
                <input
                  type="text"
                  value={weight}
                  onChange={(e) => handleWeightChange(e.target.value)}
                  placeholder="0.0"
                  className="w-full px-4 py-3 pr-12 rounded-lg border border-[var(--venere-slate)] transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-0 focus:border-[var(--venere-royal)] focus:ring-[var(--venere-royal)] placeholder:text-[var(--venere-silver)] placeholder:font-normal venere-text-primary text-base"
                />
                <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                  <span className="venere-text-primary">kg</span>
                </div>
              </div>
            </div>

            <VenereButton disabled={!weight} onClick={onRegisterClick}>
              Salva
            </VenereButton>
            <VenereBodyScanBox/>
          </div>
        </div>
      </div>
      
      {/* Dialog */}
      <VenereDialog
        isOpen={isOpen}
        onClose={hideDialog}
        title={config.title}
        primaryButton={config.primaryButton}
        secondaryButton={config.secondaryButton}
        showCloseButton={config.showCloseButton}
        size={config.size}
        className={config.className}
      >
        {config.content}
      </VenereDialog>
    </VenereSimpleLayout>
  )
}

export default VenereRegisterWeight
